import { BtnLink, FileInputProps, FormError, FormLabel } from '@mi-front/ui';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Chip } from '@mui/material';
import { useField } from 'formik';
import { useIntl } from 'react-intl';
import { UploadAsset } from './UploadAsset';

interface Props {
  name: string;
  label?: string;
  successText?: string;
  inputProps?: Partial<FileInputProps>;
  assetLink?: boolean;
}

export function UploadAssetField(p: Props) {
  const [{ value }, { error }, { setValue }] = useField(p.name);
  const { $t } = useIntl();

  return (
    <Box>
      {p.label && <FormLabel>{p.label}</FormLabel>}
      <Box display={'flex'} alignItems={'center'} gap={2}>
        {value && (
          <Chip
            variant={'outlined'}
            icon={<CheckIcon fontSize={'small'} />}
            label={
              p.successText ||
              $t({
                id: 'assets.fileUploaded',
                defaultMessage: 'Archivo cargado',
              })
            }
            onDelete={() => setValue(null)}
            deleteIcon={<DeleteIcon />}
          />
        )}
        {!value && (
          <UploadAsset
            inputProps={p.inputProps}
            onUploaded={(url) => {
              setValue(url);
            }}
          />
        )}
        {value && p.assetLink && (
          <div>
            <BtnLink size="xs" to={value} openInNewTab icon={<OpenInNewIcon />} className="mr-2">
              {$t({ id: 'assets.viewFile', defaultMessage: 'View file' })}
            </BtnLink>
          </div>
        )}
      </Box>
      <FormError error={error} />
    </Box>
  );
}
